// extracted by mini-css-extract-plugin
export default {"wrapper":"ry-z","viewport":"sy-z","container":"ty-z","slide":"uy-z"};